import React, { useState } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import { Skeleton } from '@/components/Skeleton'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

type Props = {
  alt?: string
  height: number
  onLoadingEnd?: VoidFunction
  onLoadingStart?: VoidFunction
  src: string
}

const LazyLoadImageSkeleton: React.FC<Props> = ({ alt, height, onLoadingEnd, onLoadingStart, src, ...props }) => {
  const [isImageLoaded, setIsImageLoaded] = useState<boolean>(false)

  return (
    <>
      {!isImageLoaded && (
        <Skeleton
          className={sprinkles({
            bottom: 0,
            left: 0,
            position: 'absolute',
            right: 0,
            top: 0,
          })}
          height={height}
        />
      )}
      <LazyLoadImage
        afterLoad={() => {
          setIsImageLoaded(true)
          onLoadingEnd && onLoadingEnd()
        }}
        alt={alt}
        beforeLoad={() => {
          setIsImageLoaded(false)
          onLoadingStart && onLoadingStart()
        }}
        effect="blur"
        height={height}
        src={src}
        style={{ height }}
        width={'100%'}
        {...props}
      />
    </>
  )
}

export default LazyLoadImageSkeleton
